<div class="trial-offer-dialog">
  <h2 class="dialog-title">{{ 'trialOffer.cancel.title' | translate }}</h2>
  <p class="dialog-body">
    {{ 'trialOffer.cancel.body' | translate: { date: (trialExpiry | date: 'mediumDate'), plan: paidPlanName } }}
  </p>
  <p class="dialog-error" *ngIf="errorKey">{{ errorKey | translate }}</p>

  <footer class="dialog-actions">
    <button
      mat-stroked-button
      type="button"
      [disabled]="submitting"
      (click)="onConfirm()"
      [ampTrack]="'action-button'"
      [ampTrackDetail]="'trial-offer-cancel-confirm'"
    >
      <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
      <span [class.invisible]="submitting">{{ 'trialOffer.cancel.secondary' | translate | uppercase }}</span>
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="submitting"
      (click)="onKeep()"
      [ampTrack]="'action-button'"
      [ampTrackDetail]="'trial-offer-keep'"
    >
      {{ 'trialOffer.cancel.primary' | translate | uppercase }}
    </button>
  </footer>
</div>
